<template>
  <div class="return-layout return">
    <div class="return-section">
      <div class="order-container">
        <div class="order-info">
          <div class="order-img">
            <img :src="orderInfo.imageUrl">
          </div>
          <div class="order-text">
            <h1>{{orderInfo.productName}}</h1>
            <p>
              {{orderInfo.orderNo}}
              <span v-show="isGroupCoupon" class="product-type">成套票券</span>
            </p>
            <div class="order-btm">
              <div class="order-amount">${{orderInfo.payAmount}}</div>
              <div class="order-qty">x{{orderInfo.availableQty}}</div>
            </div>
          </div>
        </div>
        <div v-show="isGroupCoupon" class="return-word">
          ※ 成套票券所產生的訂單，未能於兌換時間內將整套/組兌換完畢，或於兌換期間發生退款時，會先將已使用過的憑證轉換為原價，再進行退款相關處理。
        </div>
      </div>
    </div>

    <div class="return-section return-reason">
      <h2>{{ isRedmption ? '退款原因' : '退貨原因' }}</h2>

      <div class="reason-group">
        <div
          v-for="(radio, index) in isRedmption
            ? redmptionReason
            : deliveryReason"
          :key="'reason' + index"
          class="ma-0 py-2 reason-radio"
        >
          <input type="radio" :id="'reason' + index" :value="radio" v-model="returnModel">
          <label :for="'reason' + index"><span></span>{{radio.text}}</label>
        </div>
      </div>
      <v-textarea
        v-model="returnDetails"
        color="#222"
        class="reason-text"
        placeholder="其他退款原因"
        :rules="[requiredRule]"
        filled
        @focus='focusOther()'
        height="94px"
        hide-details="true"
        no-resize="true"
      />
      <template v-if="!isRedmption">
        <div>請問是否有收到貨：</div>
        <v-radio-group v-model="isReceived" class="ma-0">
          <v-radio class="ma-0 py-2" label="是" value="true" off-icon />
          <v-radio class="ma-0 py-2" label="否" value="false" off-icon />
        </v-radio-group>
        <v-text-field
          v-model="receiverName"
          label="收件人姓名"
          :maxlength="20"
          :rules="[specialRule]"
          validate-on-blur
        />
        <v-text-field
          v-model="receiverPhone"
          label="手機號碼"
          :maxlength="10"
          :rules="[phoneRule]"
          validate-on-blur
        />
        <v-text-field
          v-model="receiverAddress"
          label="地址"
          :maxlength="100"
          :rules="[specialRule]"
          :error-messages="addressError"
          @blur="validateAddress"
          validate-on-blur
        />
      </template>
    </div>

    <div class="return-section return-info">
      <h2>{{ isRedmption ? '退款說明' : '退貨說明' }}</h2>
      <p>按下【確認申請】後，待我們進行審核並確定完畢後，即會進行退款作業，處理完畢將會另以電子信件通知您。退款金額將直接透過 Pi 拍錢包退款，退款作業時間請參照 Pi 拍錢包內「關於 Pi 拍錢包」條款，麻煩耐心等候。 折扣碼為一次折抵，退款無法返還。</p>
    </div>

    <v-dialog
      v-model="dialog"
      persistent
      width="100%"
      max-width="345"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="return-section return-btn">
          <v-btn
          class="my-2 text-red justify-center"
          color="primary"
          block
          depressed="true"
          :disabled="formCheck"
          v-bind="attrs"
          v-on="on"
          height="48"
          >
            {{ isRedmption ? '申請退款' : '申請退貨' }}
          </v-btn>
        </div>
      </template>
      <v-card>
        <h3>
          申請退款確認
        </h3>
        <p>我同意由本平台代為處理發票及銷貨退回證明單，以加速退款作業。若退款審核成功，將會退掉訂單上未使用的憑證，按下確認後，即無法再取消退款。</p>
        <div class="dialog-btm">
          <v-btn
            color="primary"
            @click="dialog = false"
            depressed="true"
            outlined
            height="48"
          >
            再想想
          </v-btn>
          <v-btn
            color="primary"
            @click="nextStep()"
            depressed="true"
            height="48"
          >
            我同意
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <WaitingOverlay v-model="submitting" />

  </div>
</template>

<script>
import WaitingOverlay from '@/components/shared/WaitingOverlay'

export default {
  name: 'ReturnReason',
  components: {
    WaitingOverlay,
  },
  data() {
    return {
      placeHold: 0,
      productType: 0, // redemption: 0 , delivery: 1
      orderNo: '',
      bid: '',
      orderInfo: {},
      receiverName: '',
      receiverPhone: '',
      receiverAddress: '',
      returnDetails: '',
      isReceived: null,
      isAtmRefund: false,
      isGroupCoupon: false,
      addressError: '',
      returnModel: { text: '', value: 0 },
      redmptionReason: [
        { text: '服務／店家品質不好', value: 11 },
        { text: '訂不到位置', value: 12 },
        { text: '忘記使用', value: 13 },
        { text: '看到更優惠的商品', value: 14 },
        { text: '其它', value: 15 },
      ],
      deliveryReason: [
        { text: '商品品質不佳', value: 1 },
        { text: '看到更優惠的商品', value: 2 },
        { text: '商品與描述、預期不符', value: 3 },
        { text: '商品瑕疵', value: 4 },
        { text: '商品錯發、漏發', value: 5 },
        { text: '延遲出貨', value: 6 },
        { text: '其它', value: 7 },
      ],
      dialog: false,
      submitting: false,
    }
  },
  created() {
    this.orderNo = this.$route.query.orderNo
    this.bid = this.$route.query.bid
    this.productType = this.$route.query.type
    // this.isAtmRefund = this.$route.query.isAtmRefund
    this.isAtmRefund = false
    this.isGroupCoupon = this.$route.query.g
    if (!this.$route.params.fromOrder) {
      const returnInfo = JSON.parse(localStorage.getItem('returnInfo'))
      this.returnDetails = returnInfo.returnDetails
      this.returnModel = {
        text: returnInfo.returnReason,
        value: returnInfo.returnReasonOption,
      }
      this.isReceived = returnInfo.isReceived
      this.receiverName = returnInfo.receiverName
      this.receiverPhone = returnInfo.receiverPhone
      this.receiverAddress = returnInfo.receiverAddress
    } else {
      localStorage.removeItem('returnInfo')
    }
  },
  mounted() {
    this.getOrder()
  },
  methods: {
    nextStep() {
      this.submitting = true
      localStorage.setItem(
        'returnInfo',
        JSON.stringify({
          returnDetails: this.returnDetails,
          returnReason: this.returnReason,
          returnReasonOption: this.returnReasonOption,
          isReceived: this.isReceived,
          receiverName: this.receiverName,
          receiverPhone: this.receiverPhone,
          receiverAddress: this.receiverAddress,
        })
      )
      if (this.isAtmRefund) {
        this.$router.push({
          name: 'returnAtm',
          query: this.$route.query,
        })
      } else {
        this.sendReturnData()
      }
    },
    sendReturnData() {
      this.submitting = true
      if (this.isRedmption) {
        this.returnRedemption()
      } else {
        this.returnDelivery()
      }
    },
    goResult(result) {
      this.submitting = false
      this.$router.push({
        name: 'returnResult',
        query: {
          success: result,
          type: this.productType,
          isAtmRefund: this.isAtmRefund,
        },
      })
    },
    returnRedemption() {
      api
        .refund(
          this.orderNo,
          this.returnReasonOption == 15
            ? this.returnDetails
            : this.returnReason,
          this.returnReasonOption
        )
        .then(res => {
          if (res.data) {
            this.goResult(res.data.isSuccess)
          } else {
            this.goResult(false)
          }
        })
        .catch(err => {
          this.goResult(false)
          console.log(err)
        })
    },
    returnDelivery() {
      api
        .refund(
          this.orderNo,
          this.returnReasonOption == 7
            ? this.returnDetails
            : this.eturnReason,
          this.returnReasonOption,
          null,
          this.isReceived,
          this.receiverName,
          this.receiverAddress,
          this.eceiverPhone
        )
        .then(res => {
          if (res.data) {
            this.goResult(res.data.isSuccess)
          } else {
            this.goResult(false)
          }
        })
        .catch(err => {
          this.goResult(false)
        })
    },

    phoneRule: function(value) {
      if (value == null || value == '') return '必填項目'
      const pattern = /09[0-9]{8}/
      return pattern.test(value) || '請輸入正確格式'
    },
    requiredRule: function(value) {
      if (value == null || value == '') return '必填項目'
      return true
    },
    specialRule: function(value) {
      if (value == null || value == '') return '必填項目'
      const spChar = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im
      const emoji = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi
      if (spChar.test(value) || emoji.test(value)) {
        return '請輸入正確格式'
      } else {
        return true
      }
    },
    async validateAddress() {
      if (this.specialRule(this.receiverAddress) === true) {
        this.addressError = ''
        // todo api怪怪的？
        // this.addressError = '驗證中'
        // let result = false
        // await api
        //   .validateAddress(this.receiverAddress)
        //   .then(function(res) {
        //     if (res.code != 1000) {
        //       result = '請再次確認地址'
        //     } else {
        //       result = ''
        //     }
        //   })
        //   .catch(function(err) {
        //     result = '請再次確認地址'
        //   })
        // this.addressError = result
      } else {
        if (this.receiverAddress == null || this.receiverAddress == '') {
          this.addressError = '必填項目'
        } else {
          this.addressError = '請輸入正確格式'
        }
      }
    },
    getOrder() {
      console.log(this.bid)
      api
      .getOrderDetail(this.bid)
      .then(res => {
        this.orderInfo = res.data
        console.log(this.orderInfo)
      })
    },
    focusOther() {
      this.isRedmption ? 
      this.returnModel = this.redmptionReason[4] : 
      this.returnModel = this.deliveryReason[4]
    }
  }, 
  computed: {
    returnReason() {
      return this.returnModel.text || ''
    },
    returnReasonOption() {
      return this.returnModel.value || 0
    },
    isRedmption() {
      return this.productType == 0
    },
    formCheck() {
      if (this.isRedmption) {
        return (
          (this.returnReasonOption == 15 && !this.returnDetails) ||
          !this.returnReason
        )
      } else {
        return (
          !this.returnReason ||
          (this.returnReasonOption === 7 && !this.returnDetails) ||
          this.isReceived == null ||
          !this.receiverName ||
          !this.receiverPhone ||
          !this.receiverAddress ||
          this.addressError != ''
        )
      }
    },
  },
}
</script>

<style scoped lang="scss">

.order-container {
  padding: 24px 0;
  border-bottom: solid 1px rgba(152, 152, 152, 0.3);
  .order-info {display: flex;}
  .order-img {
    margin-right: 16px;
    img {
      width: 88px;
      border-radius: 16px;
    }
  }
  .order-text {
    h1 {
      margin-top: 0;
      font-size: 16px;
      font-weight: 500;
      text-align: left;
      color: #2a2b2b;
    }
    p {
        font-size: 12px;
        color: #989898;
    }
  }
  .order-btm {
    display: flex;
    .order-amount {
      font-size: 16px;
      font-weight: 500;
      color: #2a2b2b;
      margin-right: 8px;
    }
    .order-qty {
      font-size: 16px;
      font-weight: normal;
      color: #2a2b2b;
    }
  }
}

.placeHold {
  width: 0;
  height: 0;
  overflow: hidden;
}
.order-type {
  display: flex;
  flex-flow: row wrap;
}
.product-type {
  display: inline-block;
  border-radius: 16px;
  background-color: #ffbf56;
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  transform: scale(0.833333);

}
.return-layout {
  background-color: #fff;
  .return-section {
    background-color: #fff;
    padding: 0px 16px;
  }

}

.return-word {
  color: #2a2b2b;
  background-color: #fff0d6;
  padding: 16px;
  font-size: 14px;
  border-radius: 16px;
  margin-top: 16px;
}

.return-reason {
  padding: 24px 16px !important;
  h2 { 
    font-size: 16px;
    font-weight: 500;
    color: #2a2b2b;
    margin-bottom: 16px;
  }
  .reason-radio {
    position: relative;
    margin-right: 12px;
    input[type="radio"] {
      display:none;
    }
    input[type="radio"] label {
      color: #2a2b2b;
      font-size: 16px;
    }
    input[type="radio"] + label span {
      content: '';
      background-color: #d9dbde;
      display: inline-block;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      vertical-align: middle;
      cursor: pointer;
      margin-right: 16px;
    }
    input[type="radio"]:checked + label span {
      background-color: #1da7fc;
      background-image: url('~@/assets/img/radio-ticked.svg');
    }
  }
}

.reason-text {
  & >>> .v-input__slot {
    margin-top: -10px;
    padding: 4px 16px !important;
    background-color: #f3f5f8 !important;
    border-radius: 16px !important;
    min-height: 94px;
    input {
      font-size: 16px;
    }
    &:after, &:before{
      display: none;
    }
  }
  & >>> .v-text-field__details {
    height: 0;
  }
}

.return-info {
  padding-bottom: 60px !important;
  h2 {
    font-size: 16px;
    font-weight: 500;
    color: #2a2b2b;
    margin-bottom: 12px;
  }
  p {
    font-size: 14px;
    color: #8e9091;
    margin-bottom: 6px;
  }
}

.return-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  .v-btn {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.4px;
    color: #fff;
    border-radius: 8px;
  }
  & >>> .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: #c0c2c4 !important;
    color: #fff !important;
  }
}

>>> .v-dialog {
  width: 100%;
  margin: 0 16px;
  box-shadow: none;
  border-radius: 8px;
  .v-sheet.v-card {
    border-radius: 8px;
    padding: 16px;
    h3 {
      font-size: 18px;
      font-weight: 500;
      text-align: center;
      color: #292929;
      margin-bottom: 16px;
    }
    p {
      font-size: 16px;
      color: #292929;
      margin-bottom: 18px;
    }
  }
  .dialog-btm {
    display: flex;
    justify-content: space-between;
    margin: 0 -5px;
    .v-btn {
      flex: 1;
      margin: 0 5px;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: -0.4px;
      border-radius: 8px;
      &.v-btn--outlined {
        color: #1da7fc;
        background-color: transparent !important;
        border-width: 2px;
      }
    }
  }
}


</style>
